import request from '@/utils/request'

export function list(data) {
    data.json  = true
    let url = '/account/recharge/list'
    return request.post(url,data)
}

export function all() {
    let url = '/account/recharge/all'
    return request.get(url)
}

export function down(data) {
    data.json  = true
    let config = {
        responseType: 'arraybuffer',
    }
    let url =  '/account/recharge/down'
    return request.post(url,data,config)
}

export function info(id) {
    let url = '/account/recharge/info/' + id
    return request.get(url)
}

export function save(data) {
    data.json = true
    let url = '/account/recharge/save'
    return request.post(url,data)
}

export function update(data) {
    data.json = true
    let url = '/account/recharge/update'
    return request.post(url,data)
}

export function remove(data) {
    let url =  '/account/recharge/delete'
    return request.post(url,data)
}

export function options() {
    let url =  '/account/recharge/dmz/options'
    return request.get(url)
}

export function upload(file) {
    let url = '/account/recharge/upload';
    let forms = new FormData()
    forms.append("file",file)
    let config = {
        headers:{'Content-Type':'multipart/form-data'}
    }; //
    return request.post(url,forms,config)
}